import { CLOB_HOST } from '@/lib/polymarket/constants.js';

/**
 * GET /time → Unix 秒（CLOB 服务器时间）。
 * @returns {Promise<number>}
 */
export async function fetchClobServerTimeSec() {
  const res = await fetch(`${CLOB_HOST}/time`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`CLOB time HTTP ${res.status}`);
  }

  const data = await res.json();
  const sec = Number(
    typeof data === 'number' || typeof data === 'string'
      ? data
      : data?.time ?? data?.timestamp ?? data?.serverTime
  );
  if (!Number.isFinite(sec) || sec <= 0) {
    throw new Error('CLOB time invalid payload');
  }
  // 偶发毫秒时间戳
  return sec > 1e12 ? Math.floor(sec / 1000) : Math.floor(sec);
}
